const TOP_BAR: string = 'TOP_BAR';
export const SWITCH_COLOR: string = `${TOP_BAR}_SWITCH_COLOR`;
